import { isApp } from '@web3/base-utils';
import { useWalletByApp } from './appWallet';
import { useWallet } from './wallet';

/**
 * 兼容了pc与h5的钱包信息hooks，api丰富度上不及普通的pc wallet
 */
export const useHybirdWallet = () => {
  const {
    isLogin,
    hasWallet,
    evmWalletInfo,
    walletType,
    walletId,
    chainList,
    mnemonicChainList,
    needCreatedCloudWallet,
    userInfo,
    walletIsReady,
    spotIsReady,
    evmThirdPartyProvider,
    openLoginModal,
    connectBybitWallet,
    createWallet,
    openSpotLoginModal,
  } = useWallet();

  const {
    isLoginByApp,
    hasWalletByApp,
    evmWalletInfoByApp,
    userInfoByApp,
    userInfoIsReadyByApp,
    walletTypeByApp,
    walletIdByApp,
    walletIsReadyByApp,
    evmSignByApp,
    openLoginModalByApp,
    openSpotLoginModalByApp,
    connectBybitWalletByApp,
    createWalletByApp,
  } = useWalletByApp();

  if (isApp()) {
    return {
      isLogin: isLoginByApp,
      hasWallet: hasWalletByApp,
      evmWalletInfo: evmWalletInfoByApp,
      userInfo: {
        userId: userInfoByApp?.uid || '',
        email: userInfoByApp?.vagueEmail || '',
      },
      walletType: walletTypeByApp,
      walletId: walletIdByApp,
      walletIsReady: walletIsReadyByApp && userInfoIsReadyByApp,
      needCreatedCloudWallet: false,
      chainList,
      mnemonicChainList,
      openLoginModal: openLoginModalByApp,
      connectBybitWallet: connectBybitWalletByApp,
      openSpotLoginModal: openSpotLoginModalByApp,
      createWallet: createWalletByApp,
      evmSign: evmSignByApp,
    };
  }

  return {
    isLogin,
    hasWallet,
    evmWalletInfo,
    userInfo: {
      userId: userInfo?.id || '',
      email: userInfo?.vague_email || '',
    },
    walletType,
    walletId,
    needCreatedCloudWallet,
    walletIsReady: walletIsReady && spotIsReady,
    chainList,
    mnemonicChainList,
    evmSign: async (message: string) => {
      const signedData = await evmThirdPartyProvider.request({
        method: 'personal_sign',
        params: [message, evmWalletInfo.address],
      });
      return signedData;
    },
    openSpotLoginModal,
    openLoginModal,
    connectBybitWallet,
    createWallet,
  };
};
